<template>
  <div class="video-container" :style="{
    'margin-top': cc.margin_top + 'px' || gc.margin_top + 'px',
    'margin-bottom': cc.margin_bot + 'px' || gc.margin_bot + 'px',
  }">
    <div class="video-cover" v-if="cc.act_video_url && cd.outside" :style="{'border-radius': cc.border_radius + 'px','border': cc.border_color ? `2px solid ${cc.border_color}` : ''}">
      <iframe class="video-inner" :src="cc.act_video_url" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true" autoplay="1"> </iframe>  
    </div>
    <div class="video-cover" v-if="cd.url && !cd.outside" :style="{'border-radius': cc.border_radius + 'px','border': cc.border_color ? `2px solid ${cc.border_color}` : ''}">
      <video-player class="video-inner video-player vjs-custom-skin" 
        ref="videoPlayer" 
        :playsinline="true" 
        :options="playerOptions"
        >
      </video-player>
    </div> 
  </div>
</template>

<script>
import { utils } from '_lib/utils'

import { ComponentCommonMixin } from '../mixin'
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'
export default {
  mixins: [ComponentCommonMixin],
  components: {
    videoPlayer
  },
  data () {
    return {
      isVideoCover: true,
      showPlayBtn: true,
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "video/mp4", // 类型
          src: '' // url地址
        }],
        poster: '', // 封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          volumeMenuButton: false, // 音量控制
          currentTimeDisplay: true, // 当前播放时间
          remainingTimeDisplay: true, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        }
      },
    }
  },
  created () {
    this.playerOptions.sources[0].src = this.cd.url // url地址
    this.playerOptions.poster = this.cc.video_cover
    // 安卓全屏会卡死，1.3.202之前不显示全屏按钮
    if (this.querys.os_type && this.querys.version) {
      const isAndroid = this.querys.os_type.toLowerCase() === 'android' && !utils.geVersion('1.3.202')
      this.playerOptions.controlBar.fullscreenToggle = !isAndroid
    }
  },
  mounted () {
    setTimeout(() => {
      const loadingEL = document.querySelector('.vjs-loading-spinner')
      loadingEL.setAttribute('id', 'video-loading')
      const div = document.createElement('div')
      div.setAttribute('class', 'loading-circle')
      loadingEL.appendChild(div)
      // 设置播放按钮图
      const videoPlayerBtn = this.$refs['videoPlayer'] && this.$refs['videoPlayer'].$el.querySelector('.video-js .vjs-big-play-button')
      videoPlayerBtn && videoPlayerBtn.setAttribute('style', `background-image: url(${this.cc.play_btn})`)
    }, 100)
  },
  methods: {
    //播放视频 取消默认背景图
  }
}
</script>

<style lang="less">
@import '../style/videojs-cover.less';

.video-container {
  margin: 32px 14px 0;
  .video-cover {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    overflow: hidden;
    -webkit-backface-visibility: hidden;
    -moz-backface-visibility: hidden;
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    .video-img {
      position: absolute;
      z-index: 2;
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .video-inner {
      position: absolute;
      z-index: 1;
      width: 100%;
      height: 100%;
    }
  }
}

</style>